import PropTypes from 'prop-types';

const TwitterCallbackPropType = {
  onDismiss: PropTypes.func,
  onAction: PropTypes.func,
  tip: PropTypes.object,
};

export default TwitterCallbackPropType;
